// ช่อง "ส่งรายงาน" (แท็บเล็ตส่งเงินสด+ค่าใช้จ่ายแล้ว) — submit อย่างเดียวตั้งตอนจบกะ ไม่ได้แปลว่าส่งเงินแล้ว
// moneySubmitted มาจาก server: true/false = รู้สถานะ · null = server ดึงจาก seller ไม่ได้ → แสดง "ไม่ทราบสถานะ" (เทา)
// ไม่มีคีย์ moneySubmitted เลย = API เก่า → ตาม submit
export const moneySubmittedState = (row) =>
    'moneySubmitted' in row ? (row.moneySubmitted ?? null) : Boolean(row.submit);

export const isMoneySubmitted = (row) => moneySubmittedState(row) === true;
